import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import ModalRoot, { Modal, ModalBody, ModalHeader } from '../../../../components/Modal';
import { SecurityTOTPContext } from '../../../../contexts/SecurityTOTP/context';
import { TFASteps } from './TFASteps';

export const SecurityTOTPLayout = ({ children, className, currentScreen }) => {
  const { state, openScreen, closeTOTPStepsPopup } = useContext(SecurityTOTPContext);

  const TOTPSteps = state?.TOTPSteps;

  const renderedComponent = useMemo(() => {
    if (Array.isArray(children)) {
      openScreen(currentScreen);
      return children?.filter((child) => child.props.keyName === currentScreen);
    }
    openScreen(currentScreen);
    return [children]?.filter((child) => child.props.keyName === currentScreen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [children, currentScreen]);

  const showStepsSidebar = useMemo(() => {
    if (currentScreen && TOTPSteps) {
      const totpStepskeys = Object.keys(TOTPSteps);
      return totpStepskeys.includes(currentScreen);
    }
    return false;
  }, [currentScreen, TOTPSteps]);

  return (
    <div className="d-flex flex-row h-100vh main-layout totp">
      <div className="d-flex flex-row flex-fill h-100 justify-content-center totp-content">
        <div className={`w-100 position-relative totp-content-inner ${className}`}>
          {renderedComponent}
        </div>
      </div>
      {showStepsSidebar && (
        <div className="d-none d-md-block h-100 totp-sidebar bg-lighter px-4">
          <TFASteps />
        </div>
      )}
      {state?.TOTPStepsOpened && showStepsSidebar && (
        <ModalRoot rootClassName="d-md-none">
          <Modal
            contentStyle={{ maxHeight: '41rem' }}
            specialMobileContentClass="w-auto rounded-0 rounded-top py-3 px-0">
            <ModalHeader>
              <i
                onClick={closeTOTPStepsPopup}
                onKeyDown={closeTOTPStepsPopup}
                role="button"
                className="close-btn cursor-pointer icon icon-close-other text-shadow"
                tabIndex={-1}
                aria-label="Close"
              />
            </ModalHeader>
            <ModalBody>
              <TFASteps />
            </ModalBody>
          </Modal>
        </ModalRoot>
      )}
    </div>
  );
};

export default SecurityTOTPLayout;

SecurityTOTPLayout.propTypes = {
  currentScreen: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  className: PropTypes.string,
};

SecurityTOTPLayout.defaultProps = {
  children: null,
  className: '',
};
